import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import moment from "moment";

import { FetchResult } from "../../../services/doFetch";
import { Leaders, GameSummaries } from "../../../types/GameTypes";
import useAsyncError from "../../../services/useAsyncError";
import { fetchLeaders } from "../../../services/GameService";
import Spinner from "../../UI/Spinner";

import "./AllGames.scss";

function LeaderboardAllGames() {
  const [result, setResult] = useState<FetchResult<Leaders>>({ loading: false });

  const throwError = useAsyncError();

  const { loading, data } = result;

  useEffect(() => {
    (async () => {
      try {
        await fetchLeaders(setResult);
      } catch (e) {
        throwError(e);
      }
    })();
  }, [throwError]);

  const groups = data
    ? [
        { label: "3-ball games", summaries: data.for3balls },
        { label: "4-ball games", summaries: data.for4balls },
        { label: "5-ball games", summaries: data.for5balls },
      ]
    : [];

  type SectionProps = {
    label: string;
    summaries: GameSummaries;
  };

  function Section({ label, summaries }: SectionProps) {
    return (
      <>
        <thead>
          <tr>
            <th colSpan={3}>{label}</th>
          </tr>
        </thead>
        <tbody>
          {summaries.map((summary) => (
            <tr key={summary.nonce}>
              <td>{summary.player}</td>
              <td>{moment(summary.ended).format("MMM Do YYYY")}</td>
              <td>
                <Link to={`/game/${summary.nonce}`}>{summary.score}</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </>
    );
  }

  return (
    <div className="leaderboard-all-games">
      {loading && (
        <div className="spinner">
          <Spinner />
        </div>
      )}
      <div className="leaderboard-pane">
        <table>
          {data &&
            groups.map((group) => (
              <Section key={group.label} label={group.label} summaries={group.summaries} />
            ))}
        </table>
      </div>
    </div>
  );
}

export default LeaderboardAllGames;
